<template>
  <div class="mobile-header">
    <div class="header-container">
      <h2 class="logo">
        <router-link :to="{ name: ROUTE_NAME.Main }"
          ><img src="@assets/img/mobile/logo_mobile_header.svg" alt=""
        /></router-link>
      </h2>
      <ul class="right-menu-wrapper">
        <li v-if="commonStore.isSignIn" @click="membershipChangeClick">
          <b
            ><img src="@assets/img/mobile/icon_change02.svg" alt="회원권변경"
          /></b>
        </li>
        <li>
          <router-link :to="{ name: ROUTE_NAME.Reservation }">
            <b
              ><img
                src="@assets/img/contents/icon_calendar.svg"
                alt="실시간예약"
            /></b>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: ROUTE_NAME.RealCam }">
            <b
              ><img
                src="@assets/img/contents/icon_video-mobile.svg"
                alt="실시간현장"
            /></b>
          </router-link>
        </li>
        <!-- 클릭 시 메뉴 오픈 -->
        <li class="open" @click="handleToggleMenu(!isMenuClicked)">
          <span><img src="@assets/img/contents/icon_menu.svg" alt="" /></span>
        </li>
      </ul>
    </div>

    <div class="lnb-wrapper" :class="isMenuClicked ? 'active' : 'hide'">
      <div class="lnb-top">
        <ul>
          <li>
            <template v-if="commonStore.isSignIn">
              <b
                ><img src="@assets/img/contents/icon_login-mobile.svg" alt=""
              /></b>
              <span>
                {{ userStore.username }}
              </span>
              님
              <br />
              <p>환영합니다.</p>
            </template>
          </li>
          <li class="btn">
            <button v-if="!commonStore.isSignIn" class="on">
              <router-link :to="{ name: ROUTE_NAME.SignupIntro }">
                회원가입
              </router-link>
            </button>
            <button v-if="!commonStore.isSignIn">
              <router-link :to="{ name: ROUTE_NAME.Signin }">
                로그인
              </router-link>
            </button>
            <button v-if="commonStore.isSignIn" @click="handleSignOut">
              로그아웃
            </button>
          </li>
        </ul>
      </div>

      <div class="lnb-menu">
        <div class="character-back">
          <ul
            v-for="(menu, index) in menuList"
            :key="index"
            class="lnb01"
            :class="[{ open: menu.id === activeId1 }]"
          >
            <li
              v-if="!menu.useSignIn || commonStore.isSignIn"
              class="title"
              :class="[{ on: menu.id === activeId1 }]"
            >
              <a @click="() => handleMenuClick(menu)">
                {{ menu.title }}
              </a>
              <div class="list-wrap">
                <ul
                  v-for="(menu2, index2) in menu.children"
                  :key="index2"
                  class="list"
                >
                  <li
                    v-if="!menu.useSignIn || commonStore.isSignIn"
                    class="list-title"
                    :class="[{ on: menu2.id === activeId2 }]"
                  >
                    <a @click="() => handleMenuClick(menu2)">
                      {{ menu2.title }}
                    </a>
                    <ul
                      class="lnb02"
                      :class="[{ open: menu2.id === activeId2 }]"
                    >
                      <li
                        v-for="(menu3, index3) in menu2.children"
                        :key="index3"
                      >
                        <template
                          v-if="!menu.useSignIn || commonStore.isSignIn"
                        >
                          <a @click="() => handleMenuClick(menu3)">
                            {{ menu3.title }}
                          </a>
                        </template>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div class="menu-footer">
          <router-link to="/" class="logo"
            ><img src="@assets/img/mobile/footer_logo.svg" alt="푸터로고"
          /></router-link>
          <div class="footer-info">
            <p>
              (주)블루원 대표자명 : 김봉호 사업자등록번호 : 505-81-81749
              통신판매업신고 : 제 2014-경북경주-0170호<br />
              경기도 용인시 처인구 원삼면 보개원삼로1534번길 40
            </p>
            <span>copyright (c) 2016 blueone. all rights reserved.</span>
            <div class="social-icon">
              <p class="number">1899-1888</p>
              <a
                href="http://pf.kakao.com/_xfxdxmbj"
                target="_blank"
                class="kakao"
                ><img src="@assets/img/main/footer_kakao.svg" alt="카카오톡"
              /></a>
              <a href="https://naver.me/5y4qUYF3" target="_blank" class="naver"
                ><img
                  src="@assets/img/main/footer_naver.svg"
                  alt="네이버플레이스"
              /></a>
              <a
                href="https://www.instagram.com/blueone_yongin_c.c"
                target="_blank"
                class="instagram"
                ><img
                  src="@assets/img/main/footer_instagram.svg"
                  alt="인스타그램"
              /></a>
            </div>
          </div>
          <!--패밀리 사이트맵-->
          <div class="family-map">
            <div
              class="list-title"
              :class="{ open: familyList.list }"
              @click="familyList.list = !familyList.list"
            >
              <p>FAMILY SITE</p>
              <span class="icon" :class="{ active: familyList.list }"></span>
            </div>

            <ul class="list-content">
              <li>
                <a href="https://ty-holdings.co.kr/" target="_blank"
                  >TY 홀딩스</a
                >
              </li>
              <li>
                <a href="https://www.taeyoung.com/" target="_blank">태영건설</a>
              </li>
              <li><a href="https://www.sbs.co.kr/" target="_blank">SBS</a></li>
              <li>
                <a href="https://www.speedium.co.kr/" target="_blank"
                  >인제스피디움</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-menu-close" @click="isMenuClicked = false">
          <div class="btn">
            <span>닫기</span>
          </div>
        </div>

        <div class="move-site">
          <a :href="moveSite">
            <img src="@assets/img/icon_move-site-sj.svg" alt="" />
            <span
              >블루원상주<br />
              바로가기</span
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useScrollLock, useSignOut } from '@composables';
import { ROUTE_NAME } from '@constants';
import { useCommonStore, useUserStore } from '@stores';
import { computed, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const familyList = reactive({
  list: false,
});

const { lockScroll, unLockScroll } = useScrollLock();
const route = useRoute();
const router = useRouter();
const commonStore = useCommonStore();
const userStore = useUserStore();

const { handleSignOut: signOut } = useSignOut();
const isMenuClicked = ref<boolean>(false);
const handleToggleMenu = (value: boolean) => {
  isMenuClicked.value = value;
};

const moveSite = computed(() => {
  const url =
    import.meta.env.VITE_APP_NODE_ENV !== 'production'
      ? 'https://blueonesj-dev.greenit.cc'
      : 'https://sj.blueone.com';
  return url;
});
const membershipChangeClick = () => {
  const currentPath = router.currentRoute.value.fullPath;
  localStorage.setItem('redirect', currentPath);
  commonStore.setMembershipChange(true);
};
const menuList: any = [
  {
    id: '0',
    title: '클럽소개',
    children: [
      {
        id: '03',
        title: '클럽소개',
        name: ROUTE_NAME.ClubIntroduction,
      },
      {
        id: '00',
        title: '코스소개',
        children: [
          {
            id: '000',
            title: '코스안내',
            name: ROUTE_NAME.CourseInformation,
            query: { type: '0' },
          },
          {
            id: '001',
            title: '서코스(회원제)',
            name: ROUTE_NAME.CourseInformation,
            query: { type: '1' },
          },
          {
            id: '002',
            title: '중코스(회원제)',
            name: ROUTE_NAME.CourseInformation,
            query: { type: '2' },
          },
          {
            id: '003',
            title: '동코스(대중형)',
            name: ROUTE_NAME.CourseInformation,
            query: { type: '3' },
          },
        ],
      },
      {
        id: '04',
        title: '대식당 (F&B)',
        name: ROUTE_NAME.Restaurant,
      },
      {
        id: '01',
        title: '부대시설',
        children: [
          {
            id: '010',
            title: '클럽하우스 (프로샵)',
            name: ROUTE_NAME.Lobby,
          },
          // {
          //   id: '011',
          //   title: '대식당',
          //   name: ROUTE_NAME.Restaurant,
          // },
          {
            id: '012',
            title: '스타트하우스',
            name: ROUTE_NAME.HalfwayHouse,
          },
          {
            id: '013',
            title: '연회실',
            name: ROUTE_NAME.BanquetHall,
          },
          {
            id: '014',
            title: '락커&사우나',
            name: ROUTE_NAME.LockerRoom,
          },
          {
            id: '015',
            title: '주유소&편의점',
            name: ROUTE_NAME.GasStation,
          },
        ],
      },
      {
        id: '02',
        title: '오시는길',
        name: ROUTE_NAME.ClubIntroduction,
        query: {},
        hash: '#location',
      },
    ],
  },
  {
    id: '1',
    title: '이용안내',
    children: [
      {
        id: '10',
        title: '회원제 이용안내',
        children: [
          {
            id: '100',
            title: '이용방법',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '0' },
          },
          {
            id: '101',
            title: '예약안내',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '1' },
          },
          {
            id: '102',
            title: '위약규정',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '2' },
          },
          {
            id: '103',
            title: '회원특전',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '3' },
          },
          {
            id: '104',
            title: '회원권안내',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '4' },
          },
          {
            id: '105',
            title: '캐디선택 Tip',
            name: ROUTE_NAME.Guide,
            query: { type: '0', subType: '5' },
          },
        ],
      },
      {
        id: '11',
        title: '대중형 이용안내',
        children: [
          {
            id: '110',
            title: '이용방법',
            name: ROUTE_NAME.Guide,
            query: { type: '1', subType: '0' },
          },
          {
            id: '111',
            title: '예약안내',
            name: ROUTE_NAME.Guide,
            query: { type: '1', subType: '1' },
          },
          {
            id: '112',
            title: '위약규정',
            name: ROUTE_NAME.Guide,
            query: { type: '1', subType: '2' },
          },
          {
            id: '113',
            title: '이용약관',
            name: ROUTE_NAME.Guide,
            query: { type: '1', subType: '3' },
          },
        ],
      },
      {
        id: '12',
        title: '로컬룰',
        name: ROUTE_NAME.Guide,
        query: { type: '2', subType: '0' },
      },
      {
        id: '13',
        title: '단체문의',
        name: ROUTE_NAME.Guide,
        query: { type: '3', subType: '0' },
      },
      {
        id: '14',
        title: '이용약관',
        name: ROUTE_NAME.Guide,
        query: { type: '4', subType: '0' },
      },
    ],
  },
  {
    id: '2',
    title: '공지/이벤트',
    children: [
      {
        id: '20',
        title: '공지사항',
        name: ROUTE_NAME.Notice,
        query: { type: '0', subType: '0', viewType: 'list' },
      },
      {
        id: '21',
        title: '이벤트',
        name: ROUTE_NAME.Notice,
        query: { type: '1', subType: '0', viewType: 'list' },
      },
      {
        id: '22',
        title: '명예의전당',
        name: ROUTE_NAME.Notice,
        query: { type: '2', subType: '0', viewType: 'list' },
      },
    ],
  },
  {
    id: '3',
    title: '예약 및 요금',
    children: [
      {
        id: '30',
        title: '회원제예약',
        name: ROUTE_NAME.Reservation,
        query: { type: '0' },
      },
      {
        id: '31',
        title: '대중형예약',
        name: ROUTE_NAME.Reservation,
        query: { type: '1' },
      },
      {
        id: '32',
        title: '예약확인 및 취소',
        name: ROUTE_NAME.Reservation,
        query: { type: '2' },
        useSignIn: true,
      },
      {
        id: '33',
        title: '회원 요금제',
        name: ROUTE_NAME.Reservation,
        query: { type: '3', subType: '0' },
        // children: [
        //   {
        //     id: '330',
        //     title: '요금안내',
        //     name: ROUTE_NAME.Reservation,
        //     query: { type: '3', subType: '0' },
        //   },
        //   {
        //     id: '331',
        //     title: '위약규정',
        //     name: ROUTE_NAME.Reservation,
        //     query: { type: '3', subType: '1' },
        //   },
        // ],
      },
      {
        id: '34',
        title: '대중형 요금제',
        name: ROUTE_NAME.Reservation,
        query: { type: '4', subType: '0' },
      },
      {
        id: '35',
        title: '상시 우대할인',
        name: ROUTE_NAME.Reservation,
        query: { type: '5', subType: '0' },
      },
    ],
  },
  {
    id: '4',
    title: '마이페이지',
    useSignIn: true,
    children: [
      {
        id: '40',
        title: '정보수정',
        name: ROUTE_NAME.MyPage,
        query: { type: '0' },
      },
      {
        id: '41',
        title: '회원탈퇴',
        name: ROUTE_NAME.MyPage,
        query: { type: '1' },
      },
      {
        id: '42',
        title: '대중형 모바일 이용권',
        children: [
          // {
          //   id: '420',
          //   title: '모바일 이용권 구입',
          //   name: ROUTE_NAME.MyPage,
          //   query: { type: '2', subType: '0' },
          // },
          {
            id: '421',
            title: '이용권 구입 현황',
            name: ROUTE_NAME.MyPage,
            query: { type: '2', subType: '2' },
          },
          {
            id: '422',
            title: '이용권 사용 조회',
            name: ROUTE_NAME.MyPage,
            query: { type: '2', subType: '1' },
          },
        ],
      },
    ],
  },
];
const menuId = ref<string>('');
const activeId1 = computed(() => menuId.value.substring(0, 1) || '');
const activeId2 = computed(() => menuId.value.substring(0, 2) || '');

// 메뉴창을 처음 펼쳤을 때 현재 메뉴를 찾음
const setMenuActive = (list: any) => {
  list.forEach((menu: any) => {
    if (menu.children) {
      setMenuActive(menu.children);
    } else {
      if (
        menu.name == route.name &&
        JSON.stringify(menu.query || {}) == JSON.stringify(route.query) &&
        JSON.stringify(menu.hash || '') == JSON.stringify(route.hash)
      ) {
        menuId.value = menu.id;
      }
    }
  });
};

const handleSignOut = async () => {
  await signOut();
  await router.push({ name: ROUTE_NAME.Main });
};

const handleMenuClick = (selectedMenu: any) => {
  if (selectedMenu.name) {
    router.push(selectedMenu);
  } else if (menuId.value != selectedMenu.id) {
    // 대메뉴 클릭 예외
    if (selectedMenu.id.length == 1 && selectedMenu.id == activeId1.value) {
      return;
    }
    menuId.value = selectedMenu.id;
  }
};

watch(
  () => isMenuClicked.value,
  (val) => {
    if (val) {
      setMenuActive(menuList);
      lockScroll();
    } else {
      menuId.value = '';
      unLockScroll();
    }
  }
);

// 메뉴 이동 시 메뉴 팝업 닫음
watch(router.currentRoute, () => {
  handleToggleMenu(false);
});
</script>

<style scoped lang="scss">
.mobile-header {
  width: 100%;
  height: 54px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: var(--main-color);
  /*  background-image: linear-gradient(
    to right,
    rgba(34, 211, 253, 1),
    rgba(0, 61, 91, 1)
  );*/
  .header-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    position: relative;
  }
  h2.logo {
    width: 100%;
    max-width: 127px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .mobile-header > a {
    display: block;
    height: 100%;
  }
}

.right-menu-wrapper {
  display: flex;
  align-items: center;
  gap: 0 13px;
  height: 100%;
  li {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      width: 27px;
      height: 27px;
    }
  }
}

/* Menu */
.lnb-wrapper {
  width: 100%;
  background: #fff;
  position: relative;
  z-index: 100;
  //display: none;

  /* lnb - top menu */
  .lnb-top {
    padding: 0 15px;
    ul {
      width: 100%;
      height: 85px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0 35px;
      border-bottom: 1px dashed #aaaaaa;
      z-index: 100;
      background: #fff;
    }
    li:first-child {
      color: #969696;
      font-size: 1.1rem;
      font-weight: 400;
      line-height: 20px;
      b {
        display: inline-block;
        margin-right: 5px;
        vertical-align: text-top;
        img {
          display: inline-block;
        }
      }
      span {
        color: #000;
        font-weight: 700;
        display: inline-block;
        margin-right: 5px;
      }
      p {
        margin-left: 32px;
      }
    }
    .btn {
      display: flex;
      gap: 0 10px;
      button {
        width: 89px;
        height: 35px;
        border-radius: 14px;
        background: var(--btn-color);
        color: #fff;
        font-size: 0.813rem;
        font-weight: 400;
      }
      button.on {
        background: var(--main-color);
      }
    }
  }

  .move-site {
    position: relative;
    bottom: 480px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    width: 70%;
    a {
      border: 1px solid #0dbbac;
      border-radius: 10px;
      padding: 15px;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: center;
      gap: 0 13px;
      width: 100%;
      span {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }

  /* lnb - list */
  .lnb-menu {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    background: #fff;
    //padding: 25px 0 139px 0;
    padding: 25px 0 0 0;
    .character-back {
      position: relative;
      //padding-bottom: 139px;
      display: flex;
      flex-direction: column;
      gap: 20px 0;
    }
    /*    .character-back::after {
      content: '';
      position: absolute;
      right: 0;
      bottom: -139px;
      width: 147px;
      height: 219px;
      background: url('@assets/img/mobile/mobile_character_01.svg') no-repeat;
    }*/
    .lnb01 {
      display: flex;
      flex-direction: column;
      gap: 20px 0;
      padding: 0 20px;
      .title a {
        display: block;
        margin-left: 35px;
      }
      .title.on > a {
        color: var(--main-color);
        font-weight: 700;
        position: relative;
      }
      .title.on > a::before {
        content: '';
        position: absolute;
        left: -20px;
        top: 50%;
        transform: translateY(-50%);
        width: 11px;
        height: 11px;
        background: url('@assets/img/mobile/icon_menu-list.svg') no-repeat;
      }
      //.title.on > a::after {
      //  content: '';
      //  position: absolute;
      //  right: 20px;
      //  top: 50%;
      //  transform: translateY(-50%);
      //  width: 65%;
      //  height: 1px;
      //  background: #0081c1;
      //}
    }
    .list-wrap {
      background: #fafafa;
      border-radius: 20px;
      overflow: hidden;
      padding: 20px;
      margin-left: 35px;
      width: 85%;
      display: none;
      .list {
        font-size: 0.875rem;
        li a {
          margin-bottom: 15px;
          margin-left: 10px;
          position: relative;
        }
        li.list-title.on > a::after {
          content: '';
          position: absolute;
          right: -20px;
          top: 50%;
          transform: translateY(-50%);
          //width: 65%;
          width: auto;
          min-width: 40%;
          height: 1px;
          background: var(--main-color);
        }
        /*        li a::after {
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background: #000;
          position: absolute;
          left: -13px;
          top: 45%;
          transform: translateY(-50%);
        }*/
      }
    }
    .lnb02 {
      display: none;
      margin-left: 20px;
      li > a {
        margin-bottom: 15px;
        margin-left: 15px;
        position: relative;
        color: var(--main-color);
      }
      li > a::after {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background: var(--main-color);
        position: absolute;
        left: -13px;
        top: 45%;
        transform: translateY(-50%);
      }
    }
    .lnb02.open {
      display: block;
    }

    .menu-footer {
      background: #414141;
      color: #9b9b9b;
      width: 100%;
      //height: 265px;
      height: 330px;
      padding: 25px 16px;
      margin-top: 160px;
      .logo {
        display: inline-block;
        margin-bottom: 10px;
      }
      .footer-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        font-size: 0.813rem;
        line-height: 18px;
        span {
          display: block;
          margin-top: 10px;
          font-size: 0.75rem;
          text-transform: uppercase;
        }
      }
      .social-icon {
        margin-top: 10px;
        display: flex;
        align-items: center;
        gap: 0 5px;
        .number {
          font-size: 1.25rem;
          margin-right: 10px;
        }
        img {
          width: 21px;
          height: 21px;
        }
      }
    }

    /* Menu 닫기버튼 */
    .btn-menu-close {
      position: relative;
      width: 100%;
      bottom: 400px;
      right: 0;
      .btn {
        position: absolute;
        width: 49px;
        height: 46px;
        right: 0;
        background: #8b8b8b;
        border-radius: 15px 0 0 15px;
        span {
          position: absolute;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 0.75rem;
        }
      }
      .btn::before {
        content: '';
        width: 24px;
        height: 1px;
        background: #fff;
        position: absolute;
        left: 14px;
        top: 50%;
        transform: rotate(45deg);
      }
      .btn::after {
        content: '';
        width: 24px;
        height: 1px;
        background: #fff;
        position: absolute;
        left: 14px;
        top: 50%;
        transform: rotate(-45deg);
      }
    }
  }

  /* menu - open */
  .lnb01.open .list-wrap {
    display: block;
  }
  .lnb01.open .title > a {
    margin-bottom: 20px;
  }
}

/* 메뉴 모션 */
.mobile-header .lnb-wrapper.active {
  animation: showLnb 0.3s ease;
  display: block;
}

.mobile-header .lnb-wrapper.hide {
  animation: hideLnb 0.3s ease;
  display: none;
}

@keyframes showLnb {
  0% {
    opacity: 0;
    transform: translateY(-150px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes hideLnb {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-150px);
  }
}

.family-map {
  width: 134px;
  margin: 20px auto 0 auto;
  border: 1px solid #9b9b9b;
  position: relative;
  .list-title {
    font-size: 0.875rem;
    color: #9b9b9b;
    text-align: center;
    display: block;
    padding: 5px 0;
    cursor: pointer;
  }
  .list-content {
    display: none;
    position: absolute;
    top: -123px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    width: calc(100% + 1px);
    li {
      text-align: left;
      font-size: 0.813rem;
      border-bottom: 1px solid #626262;
      color: #898989;
      a {
        display: block;
        padding: 5px 10px;
      }
    }
  }
  .list-title.open ~ .list-content {
    display: block;
  }
  .icon {
    position: absolute;
    right: 3px;
    top: 53%;
    transform: translateY(-50%);
    display: block;
    width: 25px;
    height: 25px;
    background: url('@assets/img/contents/icon_footer-plus.svg') no-repeat
      center center;
  }
  .icon.active {
    background: url('@assets/img/contents/icon_footer-minus.svg') no-repeat
      center center;
  }
}
</style>
